var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"container"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":_vm.iconWidth,"width":_vm.iconHeight}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }